import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CoursePlan from "../../docs/RDL730CourseOutline.pdf";
import Background from "../../image/background8.jpg";
import Students from "../../image/rdl1.jpg";

export default function RDTAlternative() {
    return(
    <>
    <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
    <Container>
        <Row className="justify-content-center section">
            <Col md="8" sm="12" className="image-over-section">
                <h2 style={{textAlign:"center"}}>Technology Alternatives for Rural Development (RDL 730)</h2>
                <p style={{textAlign:"center"}}>The course objective is to introduce the paradigm of alternative and appropriate technologies to enable rural communities to creatively prosper in the framework of Samajikta (Social Cohesion), Parasparata (Complementarity), Samriddhi (Natural Abundance) and Saundarya Drishti (Aesthetics & Beauty).</p>
                <Button href={CoursePlan} target="_blank">Course plan <i className="bi bi-box-arrow-up-right"></i></Button>
            </Col>
        </Row>
    </Container>
    </Container>

    <Container className="section">
        <Row className="justify-content-center">
            <Col md="8">
                <img src={Students} width="100%"/>
            </Col>
        </Row>
            <h2 style={{paddingTop:"50px"}}>Course Structure</h2>
        <Row xs="1" sm="3" md="3">
            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 1 : Introduction to Rural Innovation and Entrepreneurship</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Experiential Activity</li>
                                <li>Introduction to Desi, Vernacular, Local and Grassroots</li>
                                <li>Why are Appropriate Technologies (AT) relevant?</li>
                                <li>Short Reading of Foundational Articles</li>
                                <li>Educational Documentary Film 1</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 2 : Understanding the Rural Entrepreneurial Ecosystem</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Role of Agriculture in Development</li>
                                <li>Learnings from Green Revolution</li>
                                <li>Case Study 1 : System for Rice Intensification</li>
                                <li>Organic Farming, SRI, LEISA, Composting, Biofertilisers</li>
                                <li>Educational Documentary Film 2</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 3 : AT IN ARTISANAL SECTOR</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Role of Artisanal Sector in Development</li>
                                <li>Learnings from Handloom & Handicrafts Policy</li>
                                <li>Case Study 2 : Handloom Sector in India</li>
                                <li>Frugal Innovations, Microspinning, Agri-Artisanal Linkages</li>
                                <li>Educational Documentary Film 3</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 4 : AT IN WATER AND SANITATION</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Role of Water Sanitation in Development</li>
                                <li>Domestic Systems of Water Supply and Conservation</li>
                                <li>Decentralized Water & Waste Management</li>
                                <li>Educational Documentary Film 4</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 5 : AT IN HEALTH</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Local Health Traditions</li>
                                <li>Human Health</li>
                                <li>Livestock Health</li>
                                <li>Educational Documentary Film 5</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 6 : AT IN RURAL HOUSING</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Role of Housing & Habitat in Rural Development</li>
                                <li>Innovations in Green Building Materials</li>
                                <li>Disaster Resilient Housing & Regenerative Framework</li>
                                <li>Educational Documentary Film 6</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 7 : ENTREPRENEURSHIP</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Frugal Innovations</li>
                                <li>Creating your Vibrant Social Enterprise</li>
                                <li>Value & Wealth Generation at the Grassroots</li>
                                <li>Impact Hackathon</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>MODULE 8 : TERM PAPER RESEARCH LEVEL</Card.Header>
                    <Card.Body>
                        <Card.Text>
                        <p>Individual Knowledge Sharing by learner. Each learner submits a written Term Paper (7500 Words Original Article checked for originality on Turnitin) & makes a research presentation for 20 minutes on a topic.</p>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Header>Module 9 : SUMMARY & CONCLUSIONS</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <ul>
                                <li>Reminder of Some Complex Challenges</li>
                                <li>Creative & Innovative Possibilities</li>
                                <li>New Adventures & Pathways</li>
                            </ul>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>  
        </Row>
    </Container>
    </>
    )
}